import Component from './Notices';

export default Component;
